import './App.css';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';

function App({ children }) {
  return (
    <div>
      <main>
        <Sidebar />
        <div className="main-content">
          <Navbar />
          {children}
        </div>
      </main>
    </div>
  );
}

export default App;
